<template>
  <vxe-grid
    ref="refTable"
    :columns="tableColumn"
    :data="tableData"
    :min-height="30"
    :rowConfig="{
      isCurrent: false
    }"
  >
    <template #default_remark>
      <span class="c-blue">待完成</span>
    </template>
  </vxe-grid>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tableColumn: [
        {
          title: '序号',
          type: 'seq',
          width: 50
        },
        {
          title: '物料名称',
          field: 'name'
        },
        {
          title: '物料编号',
          field: 'code'
        },
        {
          title: '规格',
          field: 'spec'
        },
        {
          title: '单位',
          field: 'unit'
        },
        {
          title: '数量',
          field: 'counts'
        },
        {
          title: '单价(元)',
          field: 'goods_price'
        },
        {
          title: '金额(元)',
          field: 'goods_amount'
        },
        {
          title: '仓位',
          field: 'cang_wei'
        },
        {
          title: '备注',
          field: 'remark',
          slots: { default: 'default_remark' }
        }
      ],
      tableData: []
    }
  },
  mounted() {
    this.tableData = [this.data]
  }
}
</script>

<style scoped>
.table-main {
}
</style>
